import { atom } from 'jotai';

type PhoneVerifyModalAtomType = {
  isOpen: boolean;
};

export const phoneVerifyModalAtom = atom<PhoneVerifyModalAtomType>({ isOpen: false });

phoneVerifyModalAtom.debugLabel = 'phoneVerifyModalAtom';
